export default __webpack_public_path__ + "static/discord-banner-0f6b0d46676bc6700668e78c23d508de.jpg";